import { useState, useEffect } from 'react';
import { categoryService, Category } from '@/lib/services/category.service';

export function useCategories(storeId?: string, parentId?: string, serverId?: string) {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!storeId) {
      setLoading(false);
      return;
    }

    const fetchCategories = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await categoryService.listByStore(storeId, parentId, serverId);
        setCategories(data);
      } catch (err) {
        console.error('Erro ao buscar categorias:', err);
        setError('Erro ao carregar categorias');
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [storeId, parentId, serverId]);

  return { categories, loading, error };
}
